import moment from "moment"
import { DATE_FORMAT } from "./constant"

export const createURL = (url: string, params: any) => {
    Object.keys(params).map((param) => {
        url = url.replace(`:${param}`, params[param])
    })
    return url
}


export const UpdateWithVariables = (url: string, data: any) => {
    if (data) {
        let dynamicParams = url.match(/:[A-Z_]*/gi)
        dynamicParams?.map(key => {
            if (key.length > 1) url = url.replace(key, data[key.replace(':', '')])
        })
    }
    return url
}

export function CheckNumber(e: { target: { value: string; getAttribute: (arg0: string) => string } }) {
    let n = e.target.value.replace(/^0+/, '').replace(/[^\d.]/g, '')
    const min: number = parseFloat(e.target.getAttribute('min'))
    const max: number = parseFloat(e.target.getAttribute('max'))
    if (n == '') {
        n = '0'
    }
    if (min && parseFloat(n) < min) {
        n = String(min)
    }

    if (max && parseFloat(n) > max) {
        n = String(max)
    }
    e.target.value = n
}

export const showDate = (dbDate: any, dateFormat: any = DATE_FORMAT) => {
    return (dbDate !== '') ? moment(dbDate).format(dateFormat) : "";
}
export const showLocalDate = (dbDate: any, dateFormat: any = DATE_FORMAT) => {
    return dbDate ? moment.utc(dbDate).local().format(dateFormat) : "-";
}

export const showLocalTime = (dbDate: any, dateFormat: any = DATE_FORMAT) => {
    return dbDate ? moment.utc(dbDate).local().format('hh:mm A') : "-";
}

export const showLocalDateTime = (dbDate: any, dateFormat: any = DATE_FORMAT) => {
    return dbDate ? moment.utc(dbDate).local().format(dateFormat) + ' ' + moment.utc(dbDate).local().format('hh:mm A') : "-";
}


export const localDate = (dbDate: any, dateFormat: any = DATE_FORMAT) => {
    return dbDate ? moment.utc(dbDate).local().toDate() : undefined;
}
export const localTime = (dbDate: any, dateFormat: any = DATE_FORMAT) => {
    return dbDate ? moment.utc(dbDate).local() : undefined;
}

export const getSelectedOption = (selectedValue: string | number, options: any[], matchWidth: string = 'value') => {
    let selected: any = null
    options?.map((option: any, i: number) => {
        if (option[matchWidth] == selectedValue) {
            if (!selected)
                selected = option
        }
    })
    return selected
}
export const getSelectedOptions = (selectedValues: string[] | number[] | null, options: any[]) => {
    const selected: any[] = []
    selectedValues?.map((value) => {
        selected.push(getSelectedOption(value, options))
    })
    return selected
}

export const downloadExcel = (data: any, fileName: string) => {
    const blob = new Blob([data], { type: 'application/vnd.ms-excel ' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);
}
export const downloadPDF = (data: any, fileName: string) => {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName + '.pdf';
    a.click();
    window.URL.revokeObjectURL(url);
}

export const exportDashboardToPDF = async (
    element: HTMLElement,
    filename: string,
    pageTitle: string
): Promise<void> => {
    const html2canvas = (await import('html2canvas')).default;
    const { jsPDF } = await import('jspdf');

    const CAPTURE_SCALE = 2;

    // Measure forced page-break positions (in content px, accounting for scroll)
    // before html2canvas clones the DOM.
    const containerRect = element.getBoundingClientRect();
    const breakPoints: number[] = [];
    element.querySelectorAll<HTMLElement>('[data-pdf-break-before]').forEach(el => {
        const elRect = el.getBoundingClientRect();
        const contentPx = elRect.top - containerRect.top + element.scrollTop;
        breakPoints.push(contentPx * CAPTURE_SCALE); // scale to canvas coords
    });
    breakPoints.sort((a, b) => a - b);

    const elementW = element.offsetWidth;
    const elementH = element.scrollHeight;

    const canvas = await html2canvas(element, {
        scale: CAPTURE_SCALE,
        useCORS: true,
        allowTaint: true,
        scrollX: 0,
        scrollY: 0,
        // Use the element's rendered (offset) width so the full container is
        // captured. windowWidth matches the real viewport so responsive charts
        // (Recharts ResponsiveContainer) compute their sizes correctly.
        width: elementW,
        height: elementH,
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        onclone: async (_doc: Document, clonedEl: HTMLElement) => {
            // Force the cloned element to its real rendered width and expose
            // the full scroll height so nothing is clipped.
            clonedEl.style.width = elementW + 'px';
            clonedEl.style.minWidth = elementW + 'px';
            clonedEl.style.height = elementH + 'px';
            clonedEl.style.overflow = 'visible';

            // Hide elements marked to be excluded from the PDF (e.g. export buttons).
            const hideStyle = _doc.createElement('style');
            hideStyle.textContent = '[data-pdf-hide] { display: none !important; }';
            _doc.head.appendChild(hideStyle);

            // Replace oklch() colors — html2canvas colour parser cannot handle them.
            // Local dev: CSS is injected as <style> tags (webpack style-loader) → patch inline.
            // Built/served env: CSS is in separate .css files via <link> → fetch, patch, replace.
            _doc.querySelectorAll('style').forEach((styleEl: HTMLStyleElement) => {
                if (styleEl.textContent) {
                    styleEl.textContent = styleEl.textContent.replace(/oklch\([^)]*\)/gi, 'inherit');
                }
            });

            const links = Array.from(_doc.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]'));
            await Promise.all(links.map(async (link) => {
                try {
                    const res = await fetch(link.href);
                    const css = (await res.text()).replace(/oklch\([^)]*\)/gi, 'inherit');
                    const inlineStyle = _doc.createElement('style');
                    inlineStyle.textContent = css;
                    link.replaceWith(inlineStyle);
                } catch {
                    // cross-origin stylesheet — leave unchanged
                }
            }));
        },
    } as any);

    const pdf = new jsPDF('p', 'mm', 'a4');
    const PAGE_W = 210;
    const PAGE_H = 297;
    const MARGIN = 10;
    const HEADER_H = 14;

    const contentW = PAGE_W - MARGIN * 2;
    const imgW = canvas.width;
    const imgH = canvas.height;
    const mmPerPx = contentW / imgW;

    pdf.setFontSize(13);
    pdf.setTextColor(30, 30, 30);
    pdf.text(pageTitle, MARGIN, MARGIN + 6);
    pdf.setFontSize(9);
    pdf.setTextColor(120, 120, 120);
    pdf.text(
        new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }),
        PAGE_W - MARGIN,
        MARGIN + 6,
        { align: 'right' }
    );

    let srcY = 0;
    let isFirstPage = true;
    let pendingBreaks = [...breakPoints];

    while (srcY < imgH) {
        const topOffset = isFirstPage ? HEADER_H : 0;
        const availablePx = (PAGE_H - MARGIN * 2 - topOffset) / mmPerPx;

        // If a forced break falls within this page's range, end the page there.
        const nextForcedBreak = pendingBreaks.find(bp => bp > srcY && bp < srcY + availablePx);
        const slicePx = nextForcedBreak
            ? nextForcedBreak - srcY
            : Math.min(availablePx, imgH - srcY);

        const sliceCanvas = document.createElement('canvas');
        sliceCanvas.width = imgW;
        sliceCanvas.height = Math.ceil(slicePx);
        const ctx = sliceCanvas.getContext('2d')!;
        ctx.drawImage(canvas, 0, -srcY, imgW, imgH);

        const imgData = sliceCanvas.toDataURL('image/jpeg', 0.92);
        pdf.addImage(imgData, 'JPEG', MARGIN, MARGIN + topOffset, contentW, slicePx * mmPerPx);

        srcY += slicePx;
        if (nextForcedBreak) {
            pendingBreaks = pendingBreaks.filter(bp => bp >= srcY);
        }

        if (srcY < imgH) {
            pdf.addPage();
            isFirstPage = false;
        }
    }

    pdf.save(`${filename}.pdf`);
};

export const getPermissionInfo = (url: string = `/`, entity_name: string = ``, loggedinuser: any): boolean => {
    
    const slugify = (str: string) => str.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    // admin user => always true
    if (loggedinuser?.userTypeID !== 1) {
        // find matching module
        console.log("get mod", loggedinuser.module);
        const module = loggedinuser.module.find((m: any) => {
            if (!m.url) return false;
            if (m.url.endsWith("^")) {
                const baseUrl = m.url.replace("^", "");
                return url === baseUrl || url.startsWith(baseUrl + "/");
            }
            return url === m.url;
        });
        

        if (module) {
            console.log("under module");
            if (module.entity.length > 0) {
                const entityRow = module.entity.find(
                    (e: any) => slugify(e.obj) === slugify(entity_name)
                );

                if (entityRow) {
                    const hasPermission = entityRow.r === 1 || entityRow.w === 1 || entityRow.d === 1;
                    if (hasPermission) return true;
                }
                // if no specific entity found, check if all permissions are zero
                // not remove this portion
                /* const allZero = module.entity.every(
                    (e: any) => e.r === 0 && e.w === 0 && e.d === 0
                );
                if (allZero) return true; */

                return false;
            } else {
                return true;
            }

        }
    }
    return true;   // admin always allowed
};
